import { Cpu } from "lucide-react";
import type { EngineStatus, Health } from "@/hooks/useEngineInfo.ts";

const MODELS: Record<string, { label: string; short: string }> = {
  soniox: { label: "Soniox API Key", short: "Soniox" },
  cloud: { label: "Cloud compute", short: "Cloud" },
};

/** Opens the admin page; shows the AI model new sessions use, green while the server is online. */
export function ModelButton({ health, status }: { health: Health | null; status: EngineStatus }) {
  const model = MODELS[health?.aiEngine ?? ""];
  const online = status === "ok";
  const state = online ? "online" : status === "unknown" ? "checking" : status === "down" ? "offline" : "model unreachable";
  return (
    <a
      href="/admin"
      className={`btn h-10 px-3 ${online ? "border-ok bg-ok text-white hover:!bg-ok hover:brightness-110" : status === "down" ? "border-danger text-danger" : ""}`}
      title={`AI model${model ? `: ${model.label}` : ""} (server ${state}). Opens the admin page.`}
      aria-label={`Model: ${model?.label ?? "unknown"}, server ${state}. Open the admin page.`}
    >
      <Cpu size={16} aria-hidden="true" />
      <span className="sm:hidden">{model?.short ?? "Model"}</span>
      <span className="hidden sm:inline">Model: {model?.label ?? "…"}</span>
    </a>
  );
}
